import { MainErrorFallback } from '@/components/errors/main';
import { Spinner } from '@/components/ui/spinner';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { AuthLoader } from './pages/auth-loader';
import { createRouter } from './pages/router';
import { ApiProvider } from '@liquidbudget/common';
import React, { useMemo } from 'react';
import { apiClient } from '@/api-client';
import { ThemeProvider } from '@/theme';
import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';
import { queryClient } from '@/api-query';

function App() {
  const router = useMemo(() => createRouter(), []);

  return (
    <SentryErrorBoundary fallback={MainErrorFallback}>
      <React.Suspense
        fallback={
          <div className="flex h-screen w-screen items-center justify-center">
            <Spinner size="xl" />
          </div>
        }
      >
        <QueryClientProvider client={queryClient}>
          <ApiProvider client={apiClient}>
            <AuthLoader
              renderLoading={() => (
                <div className="flex h-screen w-screen items-center justify-center">
                  <Spinner size="xl" />
                </div>
              )}
            >
              <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
                <RouterProvider router={router} />
              </ThemeProvider>
            </AuthLoader>
          </ApiProvider>
        </QueryClientProvider>
      </React.Suspense>
    </SentryErrorBoundary>
  );
}

export default App;
